import React from 'react';
import { useTranslation } from 'react-i18next';

const Ets2AffidavitPlaceOfDeliveryHeader = () => {
  const t = useTranslation('ets2\\ets2').t;
  return (
    <div className='row no-gutters text-muted font-weight-bold'>
      <div className="col col-sm-3">
        {t('ets2AffidavitPlaceOfDeliveryHeader.placeOfDelivery')}
        <span className='d-sm-none'>
          <span>/</span>{t('ets2AffidavitPlaceOfDeliveryHeader.status')}
        </span>
      </div>
      <div className='d-none d-sm-block col-sm-2'>
        {t('ets2AffidavitPlaceOfDeliveryHeader.status')}
      </div>
      <div className='d-none d-sm-block col-sm-5'>
        {t('ets2AffidavitPlaceOfDeliveryHeader.rejectionReason')}
      </div>
    </div>
  );
};

export default Ets2AffidavitPlaceOfDeliveryHeader;
